import { clientFetch } from '../clientFetch';

// USES GOOGLE MAPS
export const getIPApproxLocationGoogle = () => {
  return clientFetch(`/location/ip-locate`);
};
